import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager, AlertService } from 'ng-jhipster';
import { NgbTabChangeEvent, NgbTabset } from '@ng-bootstrap/ng-bootstrap';

import { CRUD_ACTIONS } from '../../shared';

import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ReservationFamily } from './reservation-family.model';
import { Reservation, ReservationService, ReservationUtilService } from '../reservation/';
import { ReservationFamilyService } from './reservation-family.service';
import { LessonUtilService } from '../lesson';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-reservation-family-detail',
    templateUrl: './reservation-family-detail.component.html'
})
export class ReservationFamilyDetailComponent implements OnInit, OnDestroy {

    private subscription: any;
    private reservationSubscription: Subscription;

    isLoadingReservations: boolean;
    reservationFamily: ReservationFamily;
    reservations: Reservation[];
    totalReservations: number;

     // variables for the tabs
    @ViewChild('tabs')
    tabSet: NgbTabset;
    currentTab: string;


    constructor(
        private jhiLanguageService: JhiLanguageService,
        private route: ActivatedRoute,
        private reservationService: ReservationService,
        private reservationFamilyService: ReservationFamilyService,
        private eventManager: EventManager,
        private alertService: AlertService,
        private reservationUtilService: ReservationUtilService
    ) {
        this.jhiLanguageService.setLocations(['reservation-family', 'lesson', 'lessonStatus', 'reservation', 'reservationStatus']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });

         this.reservationSubscription = this.eventManager
                    .subscribe('reservationListModification',
                    (response) => this.loadReservations());

    }

    public onSelectChange(event: NgbTabChangeEvent) {
        this.currentTab = event.nextId;
        this.loadTab(event.nextId);
    }

    loadTab(tabId: string) {
        switch (tabId) {
            case 'reservation-family-info-tab':
                this.load(this.reservationFamily.id);
            break;
            case 'bookings-info-tab':
                this.loadReservations();
            break;
        }
    }

    load(id: number) {
        this.reservationFamilyService.find(id).subscribe(res => {
            this.reservationFamily = res;

            this.reservationService
            .countByReservationFamilyId(this.reservationFamily.id).subscribe (
                (total: number) => this.totalReservations = total,
                (error: HttpErrorResponse) => this.onError(error)
            );

        });
    }

    private loadReservations() {
        if (!this.reservationFamily ) {
            return;
        }

        this.isLoadingReservations = true;
        this.reservationService
            .findAllByReservationFamilyId(this.reservationFamily.id).subscribe(
                (res: HttpResponse<Reservation[]>) => this.onReservationSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
            );
    }

    getLessonFamilyStyle(reservationFamily: ReservationFamily) {
        let color =  LessonUtilService.getBackgroundColorForClassType(reservationFamily.lessonFamily.classType);
        return  {'color': color};
    }

    getReservationStyle(reservation: Reservation): String {
        if (reservation) {
            return this.reservationUtilService.getReservationStyle(
                reservation.status.toString());
        }
        return 'text-info';
    }

    private onReservationSuccess(data: Reservation[], headers: any) {
        this.reservations = data;
        this.totalReservations = data ? data.length : 0;

        this.isLoadingReservations = false;
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family-detail.component.ts